import * as React from "react";
import { TextField } from "office-ui-fabric-react/lib";
import { round } from "~/util/math";

export interface Props
{
    maxDecimals?: number;
    onChange: (value: number) => void;
    value: number;
    placeholder?: string;
    disabled: boolean;
}

interface State
{
    value: string;
}

class NumberTextField extends React.Component<Props, State>
{
    state = {
        value: this.props.value.toString(),
    };

    
    
    onValueChange = (event: React.FormEvent<HTMLInputElement>, value: string) =>
    {
        const tempValue = value.replace(",", ".").replace(/[^0-9.]/g, "");
       
        this.setState({ value: tempValue });
        let result = parseFloat(tempValue);
        if (this.props.maxDecimals)
        {
            result = round(result, this.props.maxDecimals);
        }
        this.props.onChange(result);
      
    }

    render()
    {
        const { value } = this.state;
        return <TextField type="number" disabled={this.props.disabled} placeholder={this.props.placeholder}
         onChange={this.onValueChange} value={value} />;
    }
}

export default NumberTextField;


// WEBPACK FOOTER //
// ./src/components/baseComponent/NumberTextField.tsx